/* global axios */
import ApiClient from './ApiClient';
import store from '../store';

class InternalChatsAPI extends ApiClient {
  constructor() {
    super('internal_chats', { accountScoped: true });
  }

  // eslint-disable-next-line class-methods-use-this
  get accountId() {
    return store.getters.getCurrentAccountId;
  }

  async list() {
    return axios.get(this.url);
  }

  async show(id) {
    return axios.get(`${this.url}/${id}`);
  }

  async createDm(userId) {
    return axios.post(`${this.url}/dm`, { user_id: userId });
  }

  async createGroup({ name, description, memberIds, avatar }) {
    if (avatar) {
      const fd = new FormData();
      fd.append('name', name);
      if (description) fd.append('description', description);
      memberIds.forEach(id => fd.append('member_ids[]', id));
      fd.append('avatar', avatar);
      return axios.post(`${this.url}/groups`, fd, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
    }
    return axios.post(`${this.url}/groups`, {
      name,
      description,
      member_ids: memberIds,
    });
  }

  async createChannel({ name, description }) {
    return axios.post(`${this.url}/channels`, { name, description });
  }

  async update(id, payload) {
    if (payload.avatar instanceof File) {
      const fd = new FormData();
      Object.entries(payload).forEach(([k, v]) => {
        if (v !== undefined && v !== null) fd.append(k, v);
      });
      return axios.patch(`${this.url}/${id}`, fd, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
    }
    return axios.patch(`${this.url}/${id}`, payload);
  }

  async destroy(id) {
    return axios.delete(`${this.url}/${id}`);
  }

  async addMembers(id, userIds) {
    return axios.post(`${this.url}/${id}/add_members`, { user_ids: userIds });
  }

  async removeMember(id, userId) {
    return axios.delete(`${this.url}/${id}/members/${userId}`);
  }

  async markRead(id) {
    return axios.post(`${this.url}/${id}/mark_read`);
  }

  async agents(query = '') {
    return axios.get(`${this.url}/agents`, { params: { q: query } });
  }

  async listMessages(chatId, { offset = 0, limit = 50 } = {}) {
    return axios.get(
      `/api/v1/accounts/${this.accountId}/internal_chats/${chatId}/messages`,
      { params: { offset, limit } }
    );
  }

  async createMessage(chatId, { content, attachments = [] }) {
    if (attachments.length > 0) {
      const fd = new FormData();
      if (content) fd.append('content', content);
      attachments.forEach(file => fd.append('attachments[]', file));
      return axios.post(
        `/api/v1/accounts/${this.accountId}/internal_chats/${chatId}/messages`,
        fd,
        { headers: { 'Content-Type': 'multipart/form-data' } }
      );
    }
    return axios.post(
      `/api/v1/accounts/${this.accountId}/internal_chats/${chatId}/messages`,
      { content }
    );
  }

  async updateMessage(chatId, messageId, content) {
    return axios.patch(
      `/api/v1/accounts/${this.accountId}/internal_chats/${chatId}/messages/${messageId}`,
      { content }
    );
  }

  async deleteMessage(chatId, messageId) {
    return axios.delete(
      `/api/v1/accounts/${this.accountId}/internal_chats/${chatId}/messages/${messageId}`
    );
  }
}

export default new InternalChatsAPI();
